import React, { useState, useEffect } from 'react';
import { searchIcon } from '../../utility/svg';

const SearchBox = ({ placeholder, onSearch, delay = 500, className = "" }) => {
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            onSearch(searchTerm);
        }, delay);
        return () => clearTimeout(timeOutId);
    }, [searchTerm, onSearch, delay]);

    return (
        <div className={`search-container ${className}`}>
            <div className="search-box-wrapper shadow-sm">
                <span className="search-icon">{searchIcon}</span>
                <input
                    type="text"
                    className="search-input"
                    placeholder={placeholder || "Search..."}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            <style jsx="true">{`
                .search-container {
                    width: 100%;
                    max-width: 400px;
                    margin-top: 1.5rem;
                    transition: all 0.3s ease;
                }
                .search-box-wrapper {
                    display: flex;
                    align-items: center;
                    background: #fff;
                    border-radius: 50px;
                    padding: 8px 18px;
                    border: 1px solid rgba(0,0,0,0.05);
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }
                .search-box-wrapper:focus-within {
                    box-shadow: 0 8px 25px rgba(0,0,0,0.1) !important;
                    transform: translateY(-2px);
                    border-color: rgba(var(--bs-primary-rgb), 0.3);
                }
                .search-icon {
                    color: #adb5bd;
                    margin-right: 12px;
                    display: flex;
                    align-items: center;
                }
                .search-icon svg {
                    width: 18px;
                    height: 18px;
                    transition: color 0.3s ease;
                }
                .search-box-wrapper:focus-within .search-icon {
                    color: var(--bs-primary);
                }
                .search-input {
                    border: none;
                    background: transparent;
                    outline: none;
                    width: 100%;
                    font-size: 0.95rem;
                    color: #495057;
                    font-weight: 400;
                }
                .search-input::placeholder {
                    color: #adb5bd;
                    font-weight: 300;
                }
            `}</style>
        </div>
    );
};

export default SearchBox;
